export default __webpack_public_path__ + "static/5-701522f84efd0c2e276b720077fadbcd.jpg";